import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "offerResume" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "midTitle" }
const _hoisted_7 = { class: "subTitle" }
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = { class: "offerPrice resume" }
const _hoisted_10 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_11 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_12 = {
  key: 0,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_auracoin = _resolveComponent("icon-auracoin")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_description_binder = _resolveComponent("description-binder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.offer.image.publicUrl
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.offer.title.values[_ctx.$store.state.selectedLanguage]), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.offer.subTitle.values[_ctx.$store.state.selectedLanguage]), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.offer.priceConfig.grossAmount)) + " ", 1),
        (_ctx.offer.priceConfig.symbol == 'AuraCoin')
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createVNode(_component_icon_auracoin)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.offer.priceConfig.symbol), 1))
      ]),
      (_ctx.descriptionToggler)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDescription = !_ctx.showDescription))
            }, [
              (!_ctx.showDescription)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "Vedi descrizione completa",
                    text: "Vedi descrizione completa"
                  }))
                : (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    localizedKey: "Nascondi descrizione completa",
                    text: "Nascondi descrizione completa"
                  }))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_description_binder, {
        class: _normalizeClass(["description", { open: _ctx.showDescription || !_ctx.descriptionToggler }]),
        "html-text": _ctx.offer.htmlDescription.values[_ctx.$store.state.selectedLanguage]
      }, null, 8, ["class", "html-text"])
    ])
  ]))
}